// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"41912c0a","769":"6b18baac"}[chunkId] + ".chunk.js";
};